import React from "react";
import "./index.scss";
import { SparkleIcon } from "../../../assets/icons/SparkleIcon";
// ajoutez ici votre icône (format SVG ou PNG)

const CoreValues = () => {
  return (
    <div className="core-values-section">
      <div className="content-wrapper d-flex justify-content-between align-items-center W-100 p-3">
     
       <SparkleIcon />
          <span className="text">Vision</span>



       <SparkleIcon />
          <span className="text">Expertise</span>
       <SparkleIcon />
    


       

          <span className="text">Réussite</span>
            <SparkleIcon />

      </div>
            <div className="content-wrapper1 d-flex justify-content-between align-items-center  p-3">
                <div className="underline" />
                <div> <SparkleIcon /></div>
                     
                                 <div className="underline" />
            </div>
    </div>
  );
};

export default CoreValues;
